/* eslint-disable @typescript-eslint/no-explicit-any */
import Flatpickr from 'react-flatpickr';
import { Form } from 'react-bootstrap';
import classNames from 'classnames';
import { UilCalendarAlt } from '@iconscout/react-unicons';
import { renderToStaticMarkup } from 'react-dom/server';

import { NextArrowIcon, PrevArrowIcon } from 'assets/img/icons/icons';

interface DatePickerProps {
  value?: Date[] | string[];
  onChange: (selectedDates: Date[]) => void;
  placeholder?: string;
  className?: string;
  locale?: any;
  label?: string;
  mode?: 'single' | 'multiple' | 'range';
  wrapperClassName?: string;
}

const nextArrow = renderToStaticMarkup(<NextArrowIcon />);
const prevArrow = renderToStaticMarkup(<PrevArrowIcon />);

const DatePickerForm = ({
  value,
  onChange,
  placeholder,
  className = '',
  locale,
  label,
  mode = 'single',
  wrapperClassName = ''
}: DatePickerProps) => {
  return (
    <div className={classNames('flatpickr-input-container', wrapperClassName)}>
      <Form.Floating>
        <Flatpickr
          value={value}
          className={classNames('form-control', className)}
          options={{
            mode: mode,
            nextArrow: nextArrow || '',
            prevArrow: prevArrow || '',
            locale: locale,
            monthSelectorType: 'static',
            dateFormat: 'd-m-Y',
            enableTime: false,
            disableMobile: true,
            onDayCreate: (...[, , , dayElem]) => {
              if (
                dayElem.dateObj.getDay() === 5 || // Friday
                dayElem.dateObj.getDay() === 6 // Saturday
              ) {
                dayElem.className += ' weekend-days';
              }
            }
          }}
          onChange={onChange}
          placeholder={placeholder}
        />
        <label className="ps-6">{label}</label>
      </Form.Floating>
      <UilCalendarAlt className="flatpickr-icon text-700" size={16} />
    </div>
  );
};
export default DatePickerForm;
